import { render, staticRenderFns } from "./NotificationList.vue?vue&type=template&id=337e0050&scoped=true&"
import script from "./NotificationList.vue?vue&type=script&lang=js&"
export * from "./NotificationList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "337e0050",
  null
  
)

export default component.exports